var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMozambique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64888 22.2608L4.6875 27.3131C7.58275 30.2087 11.5823 31.9999 16.0007 31.9999C22.6151 31.9999 28.2909 27.9856 30.7276 22.2608H8.64888Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7525 9.79706C28.3294 4.04138 22.6374 0 16.0007 0C11.5823 0 7.58275 1.79119 4.6875 4.68681L8.69438 9.79706H30.7525Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47803 11.7681V20.1738H31.4486C31.8075 18.8431 31.9997 17.4441 31.9997 15.9999C31.9997 14.5348 31.8024 13.1161 31.4334 11.7681H3.47803Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68579 4.68628C-1.56258 10.9347 -1.56258 21.0653 4.68579 27.3138C7.26786 24.7317 9.75117 22.2484 15.9995 16L4.68579 4.68628Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47609 11.826L7.51203 15.0146H10.8649L8.15253 16.9853L9.1884 20.1739L6.47609 18.2032L3.76365 20.1739L4.79978 16.9853L2.0874 15.0146H5.44003L6.47609 11.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44385 16H9.50785V18.7826H3.44385V16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6556 12.8099L9.67175 11.826L6.475 15.0228L3.27825 11.826L2.29443 12.8099L5.494 16.0038L2.29443 19.2034L3.27825 20.1739L6.475 16.9829L9.67175 20.1739L10.6556 19.2034L7.456 16.0038L10.6556 12.8099Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambique);
export default __webpack_public_path__ + "static/media/mozambique.eb11603f.svg";
export { ForwardRef as ReactComponent };